import { FC, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Input, Form, Alert } from "antd";
import { observer, useLocalObservable } from "mobx-react";

import BrandLogo from "../../components/BrandLogo";
import { registerDevicePush } from "../../native/push";

interface Props {
  store: any;
}

const AdminLogin: FC<Props> = observer((props) => {
  const navigate = useNavigate();

  const error = useLocalObservable(() => ({ message: "" }));

  // Visiting the login page clears any existing session.
  useEffect(() => {
    props.store.accessToken = "";
    localStorage.removeItem("zw_events_session");
  }, [props.store]);

  const handleLogin = async (form) => {
    const login = await props.store.postData("auth/login", form);

    if (login.status === 200) {
      props.store.accessToken = login.data.accessToken;
      props.store.clientRef = form.clientRef;

      const session = {
        accessToken: login.data.accessToken,
        clientRef: form.clientRef,
      };
      localStorage.setItem("zw_events_session", JSON.stringify(session));

      // Native app: bind this device to the admin for organizer push.
      // Fire-and-forget — login never waits on the permission prompt.
      registerDevicePush(props.store).catch(() => {});

      navigate("/admin/manage");
    } else {
      error.message = "Invalid username or password!";
    }
  };

  return (
    <div className="flex min-h-screen w-full bg-gray-200 px-4">
      <div className="m-auto p-5 rounded-xl bg-white w-full max-w-sm shadow-sm">
        <div className="text-center">
          <BrandLogo surface="light" imgClassName="h-20 w-auto" className="mt-3 mb-4" />
          <div className="text-lg font-bold">Management Portal</div>
          {process.env.REACT_APP_VERSION && (
            <div className="mb-4 text-xs text-neutral-400">v{process.env.REACT_APP_VERSION}</div>
          )}
          {!process.env.REACT_APP_VERSION && <div className="mb-4" />}
        </div>
        <Form onFinish={handleLogin}>
          <Form.Item name="clientRef" className="mb-4">
            <Input name="clientRef" placeholder="Client Ref" />
          </Form.Item>
          <Form.Item name="email" className="mb-4">
            <Input name="email" placeholder="Email" />
          </Form.Item>
          <Form.Item name="password" className="mb-4">
            <Input.Password type="text" name="password" placeholder="Password" />
          </Form.Item>
          {error.message && <Alert message={error.message} type="error" showIcon style={{ marginTop: "10px" }} />}
          <div className="text-right mt-3">
            <Button type="primary" htmlType="submit">
              Login
            </Button>
          </div>
        </Form>
      </div>
    </div>
  );
});

export default AdminLogin;
